// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type PaginateIntercomSegmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PaginateIntercomSegmentsQuery = { labelSegments?: Array<{ id?: string, label?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, numberOfSegments: number }> };

export type GetIntercomSegmentQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetIntercomSegmentQuery = { singleLabelSegment?: { id?: string, label?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string> } };

export type UpsertIntercomSegmentMutationVariables = Types.Exact<{
  labelSegment: Types.LabelSegmentInput;
}>;


export type UpsertIntercomSegmentMutation = { upsertLabelSegment?: { id?: string, label?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string> } };


export const PaginateIntercomSegmentsDocument = gql`
    query PaginateIntercomSegments {
  labelSegments {
    id
    label
    segmentIn
    segmentNotIn
    numberOfSegments
  }
}
    `;

/**
 * __usePaginateIntercomSegmentsQuery__
 *
 * To run a query within a React component, call `usePaginateIntercomSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateIntercomSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateIntercomSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaginateIntercomSegmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>(PaginateIntercomSegmentsDocument, options);
      }
export function usePaginateIntercomSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>(PaginateIntercomSegmentsDocument, options);
        }
// @ts-ignore
export function usePaginateIntercomSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>;
export function usePaginateIntercomSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaginateIntercomSegmentsQuery | undefined, PaginateIntercomSegmentsQueryVariables>;
export function usePaginateIntercomSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>(PaginateIntercomSegmentsDocument, options);
        }
export type PaginateIntercomSegmentsQueryHookResult = ReturnType<typeof usePaginateIntercomSegmentsQuery>;
export type PaginateIntercomSegmentsLazyQueryHookResult = ReturnType<typeof usePaginateIntercomSegmentsLazyQuery>;
export type PaginateIntercomSegmentsSuspenseQueryHookResult = ReturnType<typeof usePaginateIntercomSegmentsSuspenseQuery>;
export type PaginateIntercomSegmentsQueryResult = ApolloReactCommon.QueryResult<PaginateIntercomSegmentsQuery, PaginateIntercomSegmentsQueryVariables>;
export const GetIntercomSegmentDocument = gql`
    query GetIntercomSegment($id: String!) {
  singleLabelSegment(labelSegmentId: $id) {
    id
    label
    segmentIn
    segmentNotIn
  }
}
    `;

/**
 * __useGetIntercomSegmentQuery__
 *
 * To run a query within a React component, call `useGetIntercomSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntercomSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntercomSegmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntercomSegmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables> & ({ variables: GetIntercomSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>(GetIntercomSegmentDocument, options);
      }
export function useGetIntercomSegmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>(GetIntercomSegmentDocument, options);
        }
// @ts-ignore
export function useGetIntercomSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>;
export function useGetIntercomSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetIntercomSegmentQuery | undefined, GetIntercomSegmentQueryVariables>;
export function useGetIntercomSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>(GetIntercomSegmentDocument, options);
        }
export type GetIntercomSegmentQueryHookResult = ReturnType<typeof useGetIntercomSegmentQuery>;
export type GetIntercomSegmentLazyQueryHookResult = ReturnType<typeof useGetIntercomSegmentLazyQuery>;
export type GetIntercomSegmentSuspenseQueryHookResult = ReturnType<typeof useGetIntercomSegmentSuspenseQuery>;
export type GetIntercomSegmentQueryResult = ApolloReactCommon.QueryResult<GetIntercomSegmentQuery, GetIntercomSegmentQueryVariables>;
export const UpsertIntercomSegmentDocument = gql`
    mutation upsertIntercomSegment($labelSegment: LabelSegmentInput!) {
  upsertLabelSegment(labelSegment: $labelSegment) {
    id
    label
    segmentIn
    segmentNotIn
  }
}
    `;
export type UpsertIntercomSegmentMutationFn = ApolloReactCommon.MutationFunction<UpsertIntercomSegmentMutation, UpsertIntercomSegmentMutationVariables>;

/**
 * __useUpsertIntercomSegmentMutation__
 *
 * To run a mutation, you first call `useUpsertIntercomSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIntercomSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIntercomSegmentMutation, { data, loading, error }] = useUpsertIntercomSegmentMutation({
 *   variables: {
 *      labelSegment: // value for 'labelSegment'
 *   },
 * });
 */
export function useUpsertIntercomSegmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertIntercomSegmentMutation, UpsertIntercomSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertIntercomSegmentMutation, UpsertIntercomSegmentMutationVariables>(UpsertIntercomSegmentDocument, options);
      }
export type UpsertIntercomSegmentMutationHookResult = ReturnType<typeof useUpsertIntercomSegmentMutation>;
export type UpsertIntercomSegmentMutationResult = ApolloReactCommon.MutationResult<UpsertIntercomSegmentMutation>;
export type UpsertIntercomSegmentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertIntercomSegmentMutation, UpsertIntercomSegmentMutationVariables>;